<template>
  <div class="footer">
        <div class="container">
            <div class="foot">
                <div>
                    <p>{{beianrData[0]}}</p>
                    <p style="background:url(static/img/bottom_tell.png) 0 50% no-repeat">{{tel[0]}}</p>
                </div>
                <div>
                    <span class="beian-icon"></span>
                    <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44060402002812" rel="noreferrer" target="_blank">{{beianrData[1]}}</a>
                    <p style="background:url(static/img/bottom_fax.png) 0 50% no-repeat">{{tel[1]}}</p>
                </div>
                <div>
                    <a href="https://beian.miit.gov.cn" target="_blank">{{beianrData[2]}}</a>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      beianrData:["佛山市中尔软件有限公司版权所有","粤公网安备44060402002812","粤ICP备17130885号-5"],
      tel:["服务热线 0757-82233680"]
    }
  },
  components:{},
  computed:{},
  methods:{
    getData(){

    }
  },
  mounted:function(){},
  created(){
    this.getData();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
    .footer{
        width:100%;
        height:206px;
        background:#585d5a;
        margin:0 auto;

        .foot{
            padding-top:74px;
            width:900px;
            min-width:900px;
            margin:0 auto;
            display:flex;

            & >div{
                margin:0 16.5px;
                color:#fff;
                & >p{
                    margin-bottom:8px;
                }
              & > a{
                color:#fff;
              }

                & >p:last-child:not(:first-child){
                    padding-left:24px;
                }

            }

          .beian-icon{
            display: inline-block;
            width: 15px;
            height: 15px;
            vertical-align:middle;
            background: url(/static/img/beian_logo.png);
            -webkit-background-size: 100%;
            background-size: 100%;
          }
        }


    }
</style>



// WEBPACK FOOTER //
// src/components/footer/footer.vue